export default {
  state: {

  },
  //调用方法
  mutations: {

  },
  actions: {}
};